<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Sort By Key'"
  [subTitle]="'Pipes'"
>
  <div body>
    <h5>String Ascending</h5>
    <p *ngFor="let obj of objectArray | sortByKey: 'content'">
      {{ obj.content }}
    </p>

    <h5>String Descending</h5>
    <p *ngFor="let obj of objectArray | sortByKey: 'content':false">
      {{ obj.content }}
    </p>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Sort By'"
  [subTitle]="'Pipes'"
>
  <div body>
    <h5>String Ascending</h5>
    <p>{{ stringArray | sortBy }}</p>

    <h5>String Descending</h5>
    <p>{{ stringArray | sortBy: false }}</p>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Rich Text'"
  [subTitle]="'Pipes'"
>
  <div body>
    <div [innerHTML]="html | richText"></div>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Filter Term'"
  [subTitle]="'Pipes'"
>
  <div body>
    {{ ["Hello", "World", "Hello World"] | filterTerm: "Hello" }}
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Flatten'"
  [subTitle]="'Pipes'"
>
  <div body>
    {{ flattenData | flatten }}
  </div>

  <div class="footer" footer>
    <button (click)="modifyFlatten()">Modify</button>
    <button (click)="reassignFlatten()">Reassign</button>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Credit Card Formatter'"
  [subTitle]="'Pipes'"
>
  <div body>
    <p>{{ "1111222233334444" | creditCardFormatter }}</p>
    <p>{{ "1111111111111111111" | creditCardFormatter }}</p>
    <p>{{ "a111122223333444" | creditCardFormatter }}</p>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Truncate'"
  [subTitle]="'Pipes'"
>
  <p body>
    {{
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cupiditate, ea, fugit magnam voluptatum odit fugiat cumque cum temporibus repellendus corrupti reprehenderit deserunt consequuntur laudantium libero beatae adipisci suscipit atque commodi."
        | truncate: 50
    }}
  </p>
</app-card>
